module.exports = __webpack_public_path__ + "img/h2p-avatars.db98a250.png";